import React from 'react'
import { AiOutlineInfoCircle } from 'react-icons/ai'
import { TravelGuideResType } from '../../types/global'

const GuideArticleListCard = ({ data, handleReadMore }: { data: TravelGuideResType, handleReadMore: () => void }) => {
    return (
        <div>
            <div className='font-semibold text-justify flex items-center space-x-2 text-lg'><AiOutlineInfoCircle /> <h1>{data.travel_guide_title}</h1> </div>
            <p className='text-base line-clamp-2 mt-2'><span dangerouslySetInnerHTML={{ __html: data.travel_guide_description }}></span></p>
            <button className='text-primary-dark-600 mt-2' onClick={handleReadMore}>Read Article</button>
            <hr className="my-4 border-gray-500" />
        </div>
    )
}

export default GuideArticleListCard